/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-18 11:19:44
 * @LastEditTime: 2022-03-25 11:17:00
 * @LastEditors: Yandong Hu
 * @Description:
 */

import Cookies from "js-cookie";

/**
 * 设置cookie
 *
 * @param {*} name
 * @param {*} value
 * @param {number} [expires] 过期时间小时， 不设置3天有效
 */
function setCookie(name: any, value: any, expires?: number) {
  let time = new Date();
  if(expires) {
    time = new Date(new Date().getTime() + expires * 60 * 60 * 1000);
  } else {
    time = new Date(new Date().getTime() + 2 * 24 * 60 * 60 * 1000);
  }
  Cookies.set(name, value, { expires: time });
}

/**
 * 获取cookie
 *
 * @param {string} key
 * @return {*} 
 */
function getCookie(key: string) {
  return Cookies.get(key);
}

const cookieService = {
  setCookie,
  getCookie,
};
export default cookieService;
